/**
 * @typedef {Object} PartnerScreens
 * @property {ScreenLoginTokens} login - Tokens da tela de login
 * @property {{ title: string, background: string }} primeiroAcesso - Tokens da tela de primeiro acesso
 * @property {{ title: string, text: string, info: string }} senhaPrimeiroAcesso - Tokens da tela de primeiro acesso senha
 * @property {{ titulo: string, background: string, containerGrid: { background: string } }} usuarioValidadoPage - Tokens da tela de usuario validado
 * @property {SelecaoEnvioCodigoPrimeiroAcessoTokens} selecaoEnvioCodigoPrimeiroAcesso - Tokens da tela de selecao de envio de codigo no primeiro acesso
 */

/**
 * @typedef {Object} SelecaoEnvioCodigoPrimeiroAcessoTexts
 * @property {string} title
 * @property {string} subtitleEmailOnly
 * @property {string} subtitleWithPhone
 * @property {string} labelEmail
 * @property {string} labelSms
 * @property {string} button
 */

/**
 * @typedef {Object} SelecaoEnvioCodigoPrimeiroAcessoSelectOption
 * @property {string} border
 * @property {string} selectedBorder
 * @property {string} labelColor
 * @property {string} selectedLabelColor
 * @property {string} dataColor
 */

/**
 * @typedef {Object} SelecaoEnvioCodigoPrimeiroAcessoTokens
 * @property {SelecaoEnvioCodigoPrimeiroAcessoTexts} texts
 * @property {string} title
 * @property {string} subtitle
 * @property {string} background
 * @property {string} cardBackground
 * @property {SelecaoEnvioCodigoPrimeiroAcessoSelectOption} selectOption
 */

/**
 * @typedef {Object} CustomDatePickerCalendarTokens
 * @property {string} headerBackground
 * @property {string} headerText
 * @property {string} daySelected
 * @property {string} daySelectedText
 */

/**
 * @typedef {Object} PartnerComponents
 * @property {{ background: string }} header
 * @property {{ background: string, text: string, textTransform: string }} customButton
 * @property {{ checked: string }} radioGroup
 * @property {{ border: string, icon: string, calendar: CustomDatePickerCalendarTokens }} customDatePicker
 * @property {{ color: string }} title
 * @property {{ border: string, icon: string }} input
 * @property {{ title: string }} customModal
 */

/**
 * @typedef {Object} PartnerConfig
 * @property {string} id - Identificador unico do parceiro ("bb" | "aliancaDoBrasil")
 * @property {string} displayName - Nome de exibicao do parceiro
 * @property {string} envAreaLogada
 * @property {{ logo: React.FC<React.SVGProps<SVGSVGElement>>, logoUrl: string }} header - Logo do parceiro presente no header
 * @property {string} favicon - Caminho para o favicon do parceiro
 * @property {Object} colors - Tokens de cor semanticos
 * @property {string} colors.primary - Cor primaria da marca
 * @property {string} colors.primaryDark - Variante escura da cor primaria
 * @property {string} colors.primaryLight - Variante clara da cor primaria
 * @property {string} colors.secondary - Cor secundariaz
 * @property {string} colors.success - Cor de sucesso
 * @property {string} colors.error - Cor de erro
 * @property {string} colors.warning - Cor de alerta
 * @property {string} colors.info - Cor informativa
 * @property {string} colors.background - Cor de fundo da aplicacao
 * @property {string} colors.backgroundPrimary
 * @property {string} colors.backgroundSecondary
 * @property {string} colors.backgroundDark
 * @property {string} colors.surface - Cor de superficie (cards, modais)
 * @property {string} colors.textPrimary - Cor de texto principal
 * @property {string} colors.textSecondary - Cor de texto secundario
 * @property {string} colors.textDisabled - Cor de texto desabilitado
 * @property {string} colors.border - Cor de borda padrao
 * @property {string} colors.divider - Cor de divisor
 * @property {string} colors.focus - Cor de foco (acessibilidade)
 * @property {string} colors.inverted - Cor invertida (texto sobre fundo escuro)
 * @property {Object} typography - Configuracao tipografica
 * @property {string} typography.fontFamily - Familia de fonte CSS (com fallback)
 * @property {string} typography.fontFamilyTitle - Familia de fonte CSS titulos (com fallback)
 * @property {string} typography.descriptionFontFamily - Familia de fonte CSS descrições (com fallback)
 * @property {{ light: number, regular: number, medium: number, semiBold: number, bold: number }} typography.weights - Pesos tipograficos disponiveis
 * @property {PartnerFont[]} typography.fonts - Array de fontes para injecao via @font-face
 * @property {PartnerScreens} screens - Tokens de cor segmentados por tela/contexto
 * @property {PartnerComponents} components - Overrides de estilo por componente
 */
import aliancaDoBrasil from './aliancaDoBrasil';
import bb from './bb';

/**
 * @type {Record<string, PartnerConfig>}
 */
export const PARTNER_CONFIGS = {
  bb,
  aliancaDoBrasil,
};
